<template>
  <div class="top-time">
    <div>
      <span>{{ formatSecondsTimeHm(onlineTime) }}</span>
      <span>{{ $t('lang.task.online') }}</span>
    </div>
    <div>
      <span>{{ formatSecondsTime(callTime) }}</span>
      <span>{{ $t('lang.task.calls') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onlineTime: 0,
    callTime: 0
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.top-time {
  display: flex;
  padding: 20px;
  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    > span {
      font-family: Inter-Regular;
    }
    > span:nth-child(1) {
      font-size: 24px;
      font-weight: 600;
      color: #ffffff;
      line-height: 33px;
    }
    > span:nth-child(2) {
      font-weight: 400;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>
